export type Banner = {
  header?: string;
  message?: string;
  style?: 'error' | 'success';
  icon?: BannerIcon;
};

export enum BannerIcon {
  SUCCESS = 'success-banner-icon-36',
  ERROR = 'error-banner-icon-36',
}
